import React from 'react';
import { BadgeService, Feature } from '@tencent/workbench';
import { FontFamilyFeature as ToolbarFontFamilyFeature } from '@src/framework/workbench/ui/font-family/font-family-feature';
import { configTheme } from '@src/framework/workbench/ui/font-family/config';
import { FontFamilyThemeFormController } from './font-family-theme-controller';
import FontDropdown from '@framework/workbench/drawer/components/dropdown/font-dropdown';
import { FORM_CONFIGS } from './config';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { ISlideDataModel } from '@tencent/slide-sdk-model';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Feature()
export class FontFamilyThemeFeature extends ToolbarFontFamilyFeature {
    id = configTheme.id;
    config = configTheme;

    public constructor(
        // private readonly controller: FontFamilyController,
        private readonly controller: FontFamilyThemeFormController,
        badgeService: BadgeService,
    ) {
        super(badgeService);
    }

    public renderFontFamily() {
        return (
            <div>
                <FontDropdown
                    text={this.getFontFamilyName()}
                    dropContent={this.renderSelectList()}
                    style={{ paddingLeft: 6 }}
                    fontDropStyle={{ display: 'block' }}
                    tooltip={FORM_CONFIGS[0].tooltip}
                />
            </div>
        );
    }

    public getFontFamily(): any {
        const { font } = this.getUiDataService().presentation.itemValues;
        const page = this.getSelectionService().currentSlide?.sdkData as ISlideDataModel;
        return page.getPageContext()
            .getThemeContext()
            .resolveFontTypeface(font);
    }

    public get isMasterEditType(): boolean {
        const appServices = AppServiceProvider.getInstance().getAppServices();
        if (browser.isMobile
            || appServices.getEntryType() !== AppEntryType.PC_EDIT) {
            return false;
        }
        return (appServices as IPcEditorAppServices).editableServiceLayer
            ?.masterLayoutEditService.isMasterEditType ?? false;
    }
}
